import { Component } from "@angular/core";

@Component({
    selector: 'app-view-ticket',
        templateUrl: './view-ticket.component.html',
        styleUrls: ['./view-ticket.component.scss']
})
export class ViewTicketComponent {

}